import { cn } from "@mozioinc/ui";
import SpinnerSvg from "./assets/spinner.svg?react";

export type LoadingProps = {
  color: "primary" | "secondary";
  className?: string;
};

export const Loading = (props: LoadingProps) => {
  const { color, className = "" } = props;
  return (
    <div
      className={`grid h-full w-full place-items-center ${className}`}
      role="progressbar"
    >
      <SpinnerSvg
        className={cn({
          "stroke-primary": color === "primary",
          "stroke-secondary": color === "secondary",
        })}
      />
    </div>
  );
};
